<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader title="Users Login Locations" />
        <div class="loader">
          <Wave
            v-if="loading || updating || deleting"
            width="50px"
            color="#d9534f"
          />
        </div>
      </div>
      <md-table
        v-model="userLocation.mdData"
        md-card
        md-sort="title"
        md-sort-order="asc"
      >
        <md-table-toolbar class="mb-4">
          <div class="toolbar-filter-wrapper">
            <md-field md-clearable class="md-toolbar-section-end">
              <md-input placeholder="Search by name..." v-model="search" />
            </md-field>
            <md-menu md-size="medium" md-align-trigger>
              <md-button
                md-menu-trigger
                class="md-primary button-icon"
                disabled
              >
                Filter
                <img src="@/assets/svg/filter.svg" />
              </md-button>

              <md-menu-content>
                <md-menu-item>Approved</md-menu-item>
                <md-menu-item>Pending</md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>
        </md-table-toolbar>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="S/N" md-numeric>{{ item.id }}</md-table-cell>
          <md-table-cell md-label="User IP"
            >{{ item.phone_ext }}{{ item.user_ip }}</md-table-cell
          >
          <md-table-cell md-label="Fullname" v-if="item.user">{{
            item.user.name
          }}</md-table-cell>
          <md-table-cell md-label="Email" v-if="item.user">{{
            item.user.email
          }}</md-table-cell>
          <md-table-cell md-label="Country Name">
            {{ item.country_name }}
          </md-table-cell>
          <md-table-cell md-label="Country Code">
            {{ item.country_code }}
          </md-table-cell>

          <md-table-cell md-label="Region">
            {{ item.region_name }}
          </md-table-cell>
          <md-table-cell md-label="City Name">
            {{ item.city_name }}
          </md-table-cell>
          <md-table-cell md-label="Time zone">
            {{ item.time_zone }}
          </md-table-cell>
          <!--<md-table-cell md-label="Status">
              <div
                class="badge"
                :class="{
                  success: item.approval_status == 'approved',
                  danger: item.approval_status == 'disapproved',
                }"
              >
                {{ item.approval_status }}
              </div></md-table-cell
            > -->
          <!-- <md-table-cell md-label="Actions">
            <md-menu md-size="medium" md-align-trigger>
              <md-button :disabled="updating" md-menu-trigger class="bggreen"
                >Menu</md-button
              >

              <md-menu-content>
                <md-menu-item @click="setUser(item)">Preview</md-menu-item>
                <div v-if="hasPermission">
                  <router-link
                    tag="md-menu-item"
                    :to="{ name: 'Edit User Info', params: { id: item.id } }"
                  >
                    Edit
                  </router-link>
                  <md-menu-item @click="deleteUser(item.id)"
                    >Delete</md-menu-item
                  >
                  <md-menu-item @click="loginAs(item.id, item.first_name)"
                    >Login as {{ item.first_name }}
                  </md-menu-item>
                </div>
              </md-menu-content>
            </md-menu>
          </md-table-cell> -->
        </md-table-row>
      </md-table>
      <span v-if="loading" class="b-loading">Loading...</span>
      <pagination
        v-model="userLocation.mdPage"
        :records="userLocation.mdCount"
        :per-page="userLocation.mdPerPage"
        @paginate="updatePagination"
      />
    </md-card>

    <md-dialog :md-active.sync="show">
      <md-dialog-title>User Details</md-dialog-title>
      <div class="cancel-modal">
        <i class="material-icons" @click="show = false">close</i>
      </div>

      <div class="modal-contain" v-if="user">
        <div class="item">
          <strong>First name</strong>
          <span> {{ user.first_name }}</span>
        </div>
        <div class="item">
          <strong>Last name</strong>
          <span> {{ user.last_name }}</span>
        </div>
        <div class="item">
          <strong>Email Address</strong>
          <span v-html="user.email"> </span>
        </div>
        <div class="item">
          <strong>Phone Number</strong>
          <a :href="`tel:${user.phone_ext + user.phone}`">
            {{ user.phone_ext + user.phone }}</a
          >
        </div>

        <div class="item">
          <strong>Date Created</strong>
          <span> {{ user.created_at | formatDate }}</span>
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import axios from "axios";
const { mapActions, mapGetters } = createNamespacedHelpers("userLocation");
export default {
  name: "UserLocation",
  data() {
    return {
      updating: false,
      deleting: false,
      search: "",
      show: false,
      time: null,
      usersLocation: null
      // index: 0,
    };
  },
  watch: {
    search(val) {
      this.waitForIt(val);
    }
  },

  methods: {
    ...mapActions(["index", "loginAsUser"]),
    async updatePagination(page) {
      let data = { page };
      if (this.search) data.keyword = this.search;
      await this.index();
    },
    async submitSearch() {
      await this.index({ keyword: this.search });
    },

    setUser(user) {
      this.show = true;
      this.user = user;
    },
    waitForIt(val) {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => this.submitSearch(val), 1000);
    },
    async loginAs(id, name) {
      const c = confirm(`Are you sure you want to login as ${name}?`);

      if (c) {
        const { token, redirect_url } = await this.loginAsUser(id);
        window.open(redirect_url, "_blank");
      }
    },
    async deleteUser(id) {
      const c = confirm(`Are you sure? This can't be reversed`);
      if (c) {
        alert();
      }
    }
  },
  created() {},
  mounted() {
    this.index();
  },
  computed: {
    ...mapGetters(["userLocation", "loading"]),
    hasPermission() {
      return this.$store.getters["auth/has_module_permission"]("crud");
    }
  }
};
</script>

<style lang="scss" scoped>
.md-table-cell {
  width: 0% !important;
  padding: 0rem 0.8rem;
}

.md-table + .md-table {
  margin-top: 16px;

  thead {
    height: 50px !important;
  }
}
</style>
